module.exports = __webpack_public_path__ + "assets/627d403f3790539d296f1b724fb90887.mp3";